import mutations from './patientEvidenceWithoutEesztId.mutations'
import actions from './patientEvidenceWithoutEesztId.actions'
import getters from './patientEvidenceWithoutEesztId.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
